// Accepts a .csv/.txt export from Excel/Sheets: one name per line, taking
// only the first column when a row has more than one (commas or semicolons).
export const parseSpreadsheetNames = (text) =>
  text
    .split(/\r?\n/)
    .map((line) => line.split(/[,;]/)[0].trim())
    .filter(Boolean)
